import React, { FC } from 'react';
import { AllieText, AllieCircularProgressBar } from '../../../../components';
import { FlexContainer, SvgContainer } from '../StationListSummaryCard.styles';

export const OEEContainer: FC<{ value: number; isTablet?: boolean }> = ({
  value,
  isTablet = false,
}) => {
  return (
    <FlexContainer
      flexDirection="column"
      alignItems="center"
      justifyContent={isTablet ? 'space-evenly' : 'unset'}
      gap={10}
      // style={{ width: isTablet ? '100%' : '96px', height: isTablet ? '100%' : 'unset' }}
    >
      <AllieText type="body2" className="label" color="neutral-90">
        OEE
      </AllieText>
      <SvgContainer
        style={{ height: isTablet ? '88px' : '66px', width: isTablet ? '88px' : '66px' }}
      >
        <AllieCircularProgressBar strokeWidth={10} value={value} />
      </SvgContainer>
    </FlexContainer>
  );
};
